import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ClassesItemImage from '../../layerLibrary/ClassesItemImage';
import ClassesItemLabel from '../../layerLibrary/ClassesItemLabel';

const GeoJsonLibraryLegendItem = ({ item, onLayerVisibilityToggle, iconSize }) => {
    const { type, style, label, svg } = item;
    const containerClasses = classNames('geo-json-library-legend__item', {
        'geo-json-library-legend__item--disabled': !item.visible,
    });
    const size = iconSize ? iconSize : svg.width;
    return (
        <div className={containerClasses} onClick={() => onLayerVisibilityToggle(item.layerId)}>
            <ClassesItemImage type={type} style={style} svg={svg} iconSize={size} />
            <ClassesItemLabel label={label} />
        </div>
    );
};

GeoJsonLibraryLegendItem.propTypes = {
    item: PropTypes.object.isRequired,
    onLayerVisibilityToggle: PropTypes.func.isRequired,
    iconSize: PropTypes.number,
};

export default GeoJsonLibraryLegendItem;
